// @flow strict

export const PUBLIC_URL: string = process.env.PUBLIC_URL || '';
export const API_ACCESS_TOKEN: string =
  process.env.REACT_APP_API_ACCESS_TOKEN || '';
export const API_BASE_URL: string = process.env.REACT_APP_API_BASE_URL || '';
export const QMR_API_BASE_URL: string =
  process.env.REACT_APP_QMR_API_BASE_URL || '';
